<template>
  <ul class="menu-level">
    <TheMenuItem
      v-for="(item, index) in items"
      :key="item.text"
      :content="item"
      :index="index" />
  </ul>
</template>

<script>
import TheMenuItem from './TheMenuItem'

export default {
  name: 'TheMenuLevel',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return (items.length > 0)
      }
    }
  },
  components: {
    TheMenuItem
  }
}
</script>

<style lang="scss">
  .menu-level{
    @include no-type-list;
    @include media("small-medium"){
      flex-direction: column;
      align-items: flex-start;
    }
    @include media("large"){
      flex-direction: row;
      align-items: center;
    }
    display: flex;
    justify-content: flex-start;

    > *{
      flex: 0 1 auto;
    }
  }
</style>
